export default __webpack_public_path__ + "static/media/Dr. P K. Tripathy.1b50baa7.jpeg";